export default __webpack_public_path__ + "static/media/expand.14f8edb6.svg";